import {StyleSheet} from 'react-native';

import {cloud, white} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  card: {
    backgroundColor: white,
    borderWidth: 1,
    borderColor: cloud,
    borderRadius: 9.75,
    padding: 12,
    marginHorizontal: 18,
    marginVertical: 8,
  },
  container: {
    gap: 9.75,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 41,
  },
  userInfo: {
    gap: 6,
  },
  loadingName: {
    width: 100,
    height: 16,
    borderRadius: 4,
  },
  loadingRole: {
    width: 60,
    height: 12,
    borderRadius: 4,
  },
  headerRight: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
  },
  loadingOrderType: {
    width: 70,
    height: 14,
    borderRadius: 4,
  },
  loadingBadge: {
    width: 60,
    height: 20,
    borderRadius: 4,
  },
  detailsRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: 10,
  },
  datesContainer: {
    gap: 6,
    flex: 1,
  },
  loadingDetailText: {
    width: '80%',
    height: 14,
    borderRadius: 4,
  },
  loadingOrderNumber: {
    width: 100,
    height: 14,
    borderRadius: 4,
  },
  statsContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    marginTop: 4,
  },
  statItem: {
    gap: 6,
  },
  loadingStatLabel: {
    width: 40,
    height: 12,
    borderRadius: 4,
  },
  loadingStatValue: {
    width: 50,
    height: 18,
    borderRadius: 4,
  },
  totalContainer: {
    alignItems: 'flex-end',
    gap: 6,
  },
  loadingTotalLabel: {
    width: 40,
    height: 12,
    borderRadius: 4,
  },
  loadingTotalValue: {
    width: 70,
    height: 18,
    borderRadius: 4,
  },
});
